module.exports = __webpack_public_path__ + "img/NL680.ef2f4220.png";